module.exports = __webpack_public_path__ + "img/gifts.fdb668ac.svg";